if (!customElements.get('site-header')) {
  customElements.define(
    'site-header',
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-menu-toggle]');
        this.menu = this.querySelector('[data-menu]');
        this.label = this.querySelector('[data-menu-label]');
        this.header = this.querySelector('[data-header]');
        if (!this.toggle || !this.menu || !this.header) return;

        this.events = new AbortController();

        this.toggle?.addEventListener('click', () => this.setOpen(!this.isOpen), {
          signal: this.events.signal,
        });
        document.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape') return;

            const disclosure = event.target.closest?.('details[open]');
            if (disclosure && this.contains(disclosure)) {
              disclosure.open = false;
              disclosure.querySelector(':scope > summary')?.focus();
              return;
            }

            if (!this.isOpen) return;
            this.setOpen(false);
            this.toggle?.focus();
          },
          { signal: this.events.signal }
        );

        this.desktop = window.matchMedia('(width >= 768px)');
        this.desktop.addEventListener('change', () => this.setOpen(false), {
          signal: this.events.signal,
        });

        this.publishHeight();
        if ('ResizeObserver' in window && this.header) {
          this.resizeObserver = new ResizeObserver(() => this.publishHeight());
          this.resizeObserver.observe(this.header);
        }

        this.menu.hidden = true;
        this.setAttribute('data-enhanced', '');
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
      }

      get isOpen() {
        return this.hasAttribute('data-open');
      }

      setOpen(open) {
        this.toggleAttribute('data-open', open);
        if (this.menu) this.menu.hidden = !open;
        this.toggle?.setAttribute('aria-expanded', String(open));
        if (this.label) {
          this.label.textContent = open
            ? this.dataset.menuCloseLabel
            : this.dataset.menuOpenLabel;
        }
      }

      publishHeight() {
        if (!this.header) return;
        document.documentElement.style.setProperty(
          '--header-height',
          `${Math.round(this.header.getBoundingClientRect().height)}px`
        );
      }
    }
  );
}
